import { useEffect, useRef } from "react";

/**
 * Global keyboard shortcut for the command palette.
 *
 * macOS: Meta+K   (Cmd+K)
 * everywhere else: Ctrl+K
 *
 * Callers wire this at the top of the admin app (`AdminLayout`) so the
 * palette is reachable from any screen.
 */
export function useCommandKShortcut(callback: () => void): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const isMac = /Mac/i.test(navigator.userAgent);

    function onKey(event: KeyboardEvent) {
      if (event.key.toLowerCase() !== "k") return;
      const modifier = isMac ? event.metaKey : event.ctrlKey;
      if (!modifier) return;
      event.preventDefault();
      callbackRef.current();
    }

    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
    };
  }, []);
}
